module.exports = __webpack_public_path__ + "img/logo-company-full-horizontal-white.500c5b17.svg";